export default {
  system: {
    requestUrl: process.env.VUE_APP_URL,
    fileUrl: process.env.VUE_APP_FILE_URL,
    // requestUrl: 'http://localhost:8080',
    // wsUrl: process.env.VUE_APP_WS_URL,
  },
  urlMap: {
    zm: 'https://www.zmbeidiao.com/',
  },
};
